import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// Actions
import {
  getSettings,
  updateHistoricalDataSettings,
  updateMaintenanceSettings,
} from "store/actions";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Spinner,
  Container,
  Card,
  CardBody,
} from "reactstrap";
import Select from "react-select";
import { Alert, Button } from "react-bootstrap";
import usePermission from "hooks/usePermission";

const HisotricalDataSetting = () => {
  // const  t =useTransition();
  const dispatch = useDispatch();
  const { settings, loading, error } = useSelector(({ Settings }) => Settings);

  const [fields, setFields] = useState({
    historicalData: {
      removeDataStatus: "disabled",
      emails: [],
      beforeDay: "",
      backupDay: "",
    },
  });
  const { hasPermission } = usePermission();
  const permissions = {
    add: false,
    edit: hasPermission("view_historical_data_setting"),
    delete: false,
  };

  useEffect(() => {
    dispatch(getSettings());
  }, []);

  useEffect(() => {
    if (settings?._id) {
      setFields((prevState) => ({
        ...prevState,
        historicalData: settings?.historicalData,
      }));
    }
  }, [JSON.stringify(settings)]);

  const handleChangeString = (key) => (event) => {
    const { name, value } = event.target;
    let copySettings = { ...fields };
    copySettings = {
      ...copySettings,
      [key]: { ...copySettings[key], [name]: value },
    };
    setFields(copySettings);
  };

  function submit() {
    dispatch(
      updateHistoricalDataSettings({
        data: {
          removeDataStatus: fields?.historicalData?.removeDataStatus,
          emails: fields?.historicalData?.emails,
          beforeDay: fields?.historicalData?.beforeDay,
          backupDay: fields?.historicalData?.backupDay,
        },
      }),
    );
  }

  const onHandleAddEmail = () => {
    setFields((pre) => ({
      ...pre,
      historicalData: {
        ...pre.historicalData,
        emails: [...pre.historicalData.emails, ""],
      },
    }));
  };

  const onHandleRemoveEmail = (index) => {
    let emails = [...fields.historicalData.emails];
    emails.splice(index, 1);

    setFields((pre) => ({
      ...pre,
      historicalData: { ...pre.historicalData, emails },
    }));
  };

  const handleChangeEmail = (index, value) => {
    let emails = [...fields.historicalData.emails];
    emails.splice(index, 1, value);

    setFields((pre) => ({
      ...pre,
      historicalData: { ...pre.historicalData, emails },
    }));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col sm={12} lg={12}>
              <Card>
                <CardBody className="spinner-content">
                  {error && typeof error === "string" ? (
                    <Alert color="danger">{error}</Alert>
                  ) : null}

                  {loading && <div className="spinner"></div>}

                  <Col lg={8}>
                    <div className="label-content">
                      <h4>Historical Data Settings</h4>
                    </div>
                  </Col>

                  <Col lg={8}>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <Label>
                            Status{" "}
                            <span
                              className="text-muted d-block"
                              style={{ fontSize: 11 }}
                            >
                              (If the status is enable than we can delete the
                              data from mongo DB)
                            </span>
                          </Label>

                          {/* <div className="d-flex align-items-center">
                            <input
                              type="checkbox"
                              disabled={!permissions.edit}
                              checked={
                                fields?.maintenance?.status === false
                                  ? false
                                  : true
                              }
                              id="status"
                              className="form-check"
                              onClick={() => {
                                const value =
                                  fields?.maintenance?.status === false
                                    ? true
                                    : false;

                                handleChangeString("maintenance")({
                                  target: { name: "status", value: value },
                                });
                              }}
                            />
                            <label htmlFor="status" className="form-lable pl-2">
                              {" "}
                              Under Maintenance
                            </label>
                          </div> */}
                          <FormGroup>
                            <Input
                              type="select"
                              name="removeDataStatus"
                              value={fields?.historicalData?.removeDataStatus}
                              onChange={handleChangeString("historicalData")}
                              disabled={!permissions.edit}
                            >
                              <option value="enabled">Enabled</option>
                              <option value="disabled">Disabled</option>
                            </Input>
                          </FormGroup>
                        </FormGroup>
                      </Col>
                      <Col md={12} className="my-2">
                        <FormGroup>
                          <Label>Alert Emails </Label>

                          {fields?.historicalData.emails?.map(
                            (email, index) => {
                              return (
                                <div className="d-flex m-2">
                                  <input
                                    placeholder="Enter email..."
                                    value={email}
                                    onChange={(e) =>
                                      handleChangeEmail(index, e.target.value)
                                    }
                                    disabled={!permissions.edit}
                                    className="mr-2"
                                    style={{ width: 200, height: 35 }}
                                  />
                                  {permissions.edit ? (
                                    <Button
                                      onClick={() => onHandleRemoveEmail(index)}
                                    >
                                      Remove
                                    </Button>
                                  ) : null}
                                </div>
                              );
                            },
                          )}
                        </FormGroup>
                      </Col>
                      {permissions.edit ? (
                        <Col md={12} className="my-2">
                          <Button onClick={() => onHandleAddEmail()}>
                            Add
                          </Button>
                        </Col>
                      ) : null}
                      <Col sm={6} className="my-2">
                        <FormGroup>
                          <Label>Delete Data Before (Days)</Label>
                          <Input
                            type="number"
                            name="beforeDay"
                            value={fields?.historicalData?.beforeDay}
                            onChange={handleChangeString("historicalData")}
                            disabled={!permissions.edit}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={6} className="my-2">
                        <FormGroup>
                          <Label>Backup Before (Days)</Label>
                          <Input
                            type="number"
                            name="backupDay"
                            value={fields?.historicalData?.backupDay}
                            onChange={handleChangeString("historicalData")}
                            disabled={!permissions.edit}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} className="my-2" />
                      {permissions.edit ? (
                        <Col className="d-flex justify-content-end">
                          {loading && (
                            <Spinner color="primary" className="mr-2" />
                          )}

                          <Button className="btn btn-primary" onClick={submit}>
                            Save Changes
                          </Button>
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default HisotricalDataSetting;
